import React, { Fragment } from 'react';
import * as S from './style';
import { ContentsContainer, ItemInfo, ItemInfoContainer, FileImg, Row } from 'components';
import ItemInfoBtn, { Props as ItemInfoBtnProps } from 'components/molecules/ItemInfoBtn';
import {
    LABEL_EMAIL_ADDR,
    LABEL_CARRIERYEAR,
    TITLE_PROFILE,
    ITEM_INFO_OWNER,
    ITEM_INFO_FRANCHISE,
    ITEM_INFO_SERVICE_LOCATION,
    ITEM_INFO_INTRODUCE,
    TITLE_CAR_INFO,
    TITLE_BUSINESS_INFO,
    ITEM_INFO_BUSINESS_REGISTRATION,
    ITEM_INFO_INDEMNITY_INSURANCE,
} from 'commons/ZimssaString';

interface Props {
    email: string;
    carrierYear: string;
    serviceImage: string;
    serviceOwner: string;
    franchiseName?: string;
    location: string;
    introduce: string;
    car: Array<{
        count: string;
        info: string;
    }>;
    businessRegistration: ItemInfoBtnProps;
    arrangeLicense: ItemInfoBtnProps;
    isindemnityInsurance?: string;
    isOwner: boolean;
}
function ServiceInfo({ ...props }: Props): React.ReactElement {
    return (
        <S.ServiceInfo>
            <ContentsContainer title={TITLE_PROFILE}>
                <ItemInfoContainer>
                    <ItemInfo title={LABEL_EMAIL_ADDR} contents={props.email} bold />
                    <ItemInfo title={LABEL_CARRIERYEAR} contents={props.carrierYear} bold />
                </ItemInfoContainer>
                {props.serviceImage ? (
                    <Row>
                        <FileImg inputName={''} imgDir={''} isDeleteBtn={false} value={props.serviceImage} />
                    </Row>
                ) : null}
                <ItemInfoContainer>
                    <ItemInfo title={ITEM_INFO_OWNER} contents={props.serviceOwner} bold />
                    {props.franchiseName ? <ItemInfo title={ITEM_INFO_FRANCHISE} contents={props.franchiseName} bold /> : null}
                    <ItemInfo title={ITEM_INFO_SERVICE_LOCATION} contents={props.location} bold />
                    <ItemInfoBtn title={ITEM_INFO_INTRODUCE} contents={props.introduce} />
                </ItemInfoContainer>
            </ContentsContainer>

            {props.isOwner ? (
                <Fragment>
                    <ContentsContainer title={TITLE_CAR_INFO}>
                        <ItemInfoContainer>
                            {props.car.map((item, index) => (
                                <ItemInfoBtn key={index} title={`${index + 1}번 차량(${item.count}대)`} contents={item.info} />
                            ))}
                        </ItemInfoContainer>
                    </ContentsContainer>
                    <ContentsContainer title={TITLE_BUSINESS_INFO}>
                        <ItemInfoContainer>
                            <ItemInfoBtn title={ITEM_INFO_BUSINESS_REGISTRATION} {...props.businessRegistration} />
                            <ItemInfoBtn {...props.arrangeLicense} />
                            {props.isindemnityInsurance ? <ItemInfoBtn contents={ITEM_INFO_INDEMNITY_INSURANCE} href={props.isindemnityInsurance} /> : null}
                        </ItemInfoContainer>
                    </ContentsContainer>
                </Fragment>
            ) : null}
        </S.ServiceInfo>
    );
}

export default ServiceInfo;
